/**
 * Admin "Documents" tab for one apartment (owner-portal item 6). Staff
 * uploads land as source='admin' (view-only for the owner); anything the
 * owner uploaded themselves shows here too, read-only, labeled "From owner".
 *
 * The list itself is DocumentsPanel, shared with the property- and room-level
 * tabs — this file is now just the apartment binding.
 */
import { DocumentsPanel } from "@/components/admin/v2/documents/DocumentsPanel";

export function ApartmentDocumentsTab({
  apartmentId,
  propertyId,
}: {
  apartmentId: number;
  propertyId: number;
}) {
  return (
    <DocumentsPanel
      scope="apartment"
      propertyId={propertyId}
      apartmentId={apartmentId}
      source="admin"
    />
  );
}
